import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { UserPlus, Calendar as CalIcon, Money, ChatCircle, ClockCounterClockwise, ChartBar, CheckCircle } from "@phosphor-icons/react";

const STEPS = [
  {
    icon: UserPlus, title: "Kayıt Olma & Giriş",
    body: [
      "Ana giriş sayfasında \"Kayıt ol\" bağlantısına tıklayın.",
      "Kişisel bilgileri doldurun, maaş talebinizi yazın, imzanızı çizip Onayla'ya basın, KVKK kutucuğunu işaretleyin ve gönderin.",
      "Adminin onayından sonra e-posta veya telefon + şifre ile giriş yapabilirsiniz. Beni unutma seçeneği ile uzun süreli oturum açabilirsiniz.",
    ],
  },
  {
    icon: ClockCounterClockwise, title: "İzin Talebi",
    body: [
      "Soldaki menüden \"İzinler\" → \"Yeni Talep\" düğmesine tıklayın.",
      "İzin türünü seçin (Yıllık, Mazeret, Hastalık vs.), tarihleri girin, gün sayısını yazın.",
      "\"Not\" kutusuna varsa kişisel hafta tatili günlerinizi yazabilirsiniz; sistem resmi tatilleri otomatik ekler.",
      "İmzanızı ekleyip Gönder'e basın. Talep önce müdürünüze, sonra admine gider. Yıllık izinlerde ayrıca 3 kurul üyesi imzası gereklidir.",
      "Yıllık iznin en az bir parçası 10 günden az olamaz — sistem bu kontrolü yapar.",
    ],
  },
  {
    icon: CalIcon, title: "Vardiya & Takvim",
    body: [
      "Takvim sayfasında resmi tatilleri, toplantıları ve doğum günlerini görebilirsiniz.",
      "Vardiya Planı sayfasında müdürünüz size Sabah/Öğlen/Gece vardiyalarını atar. Onaylı izinler otomatik olarak İzinli görünür.",
    ],
  },
  {
    icon: Money, title: "Ücret Pusulası (Bordro)",
    body: [
      "Admin/İK bordronuzu yüklediğinde bildirim gelir. \"Ücret Pusulaları\" sayfasına gidin.",
      "PDF'e tıklayıp inceleyin. Doğru ise Onayla düğmesi ile imzalayın; hata varsa Reddet + açıklama yazın.",
      "6 gün içinde işlem yapmalısınız. Reddettiğinizde admin bilgilendirilir; düzeltip yeniden gönderir.",
    ],
  },
  {
    icon: ChatCircle, title: "Mesajlaşma",
    body: [
      "Mesajlar sayfasından Yeni Mesaj açın. Personel → adminine/müdürüne; müdür → departmanına; admin → herkese veya seçili departmanlara mesaj atabilir.",
      "Gönderdiğiniz mesajın \"okundu\" göstergesi ile kimlerin okuduğunu takip edebilirsiniz.",
    ],
  },
  {
    icon: CheckCircle, title: "Yıllık İzin Mütabakatı",
    body: [
      "Yıl sonunda \"Yıllık İzin Mütabakatı\" sayfasında yıllık izin hak/kullanılan/kalan gün sayınızı görürsünüz.",
      "Detayları kontrol edip \"Mütabık — İmzala\" ile onaylayın; admin ve İK sonuçları takip eder.",
    ],
  },
  {
    icon: ChartBar, title: "Raporlar",
    body: [
      "Müdür kendi departmanının, admin/İK/genel müdür tüm şirketin raporlarını görür.",
      "CSV/Excel dışa aktarma seçeneği ile veriler indirilebilir.",
    ],
  },
];

export default function Guide() {
  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Yardım</div>
        <h1 className="font-display text-3xl font-bold mt-1">Kullanım Kılavuzu</h1>
        <div className="text-sm text-muted-foreground mt-1">Colossae Personel uygulamasını en iyi şekilde kullanmak için adım adım rehber.</div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {STEPS.map((s, i) => (
          <Card key={s.title}>
            <CardContent className="p-6 space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent/15 text-accent flex items-center justify-center"><s.icon size={22} /></div>
                <div>
                  <Badge variant="secondary">{i + 1}</Badge>
                  <div className="font-display font-bold text-lg mt-1">{s.title}</div>
                </div>
              </div>
              <ul className="text-sm text-muted-foreground space-y-1 list-disc pl-5">
                {s.body.map((b) => <li key={b}>{b}</li>)}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
